import React from 'react'
import {
    TextInput,
    SelectInput,
    Edit,
    FormTab,
    required,
    CardActions,
    ListButton,
    ShowButton,
    Toolbar,
    SaveButton,
    BooleanInput,
    TabbedForm,
    ArrayInput,
    SimpleFormIterator,
    CheckboxGroupInput,
    SelectArrayInput ,
    SimpleForm
    } from 'react-admin'
import withStyles from '@material-ui/core/styles/withStyles';
import TitleCheckCom from '../controls/TitleCheckCom';
import UserCheckCom from '../controls/UserCheckCom'
import {RichTextInput} from 'ra-input-rich-text';

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const TrainingActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath='/setuptrainings' label='Trainging List'/>
    </CardActions>
);

const TrainingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect={'/setuptrainings'}
            submitOnEnter={true}
        />

    </Toolbar>
);

const Roles = [
    {id: '1', name: "User"},
    {id: '2', name: "Donor Processor"},
    {id: '6', name: "Plasma Processor"},
    {id: '7', name: "QA User"},
    {id: '8', name: "Site Manager"},
    {id: '9', name: "General Manager"},
    {id: '4', name: "Phlebotomy"},
    {id: '5', name: "Physician Substitute"},
    {id: '3', name: "Control Desk"},
    {id: '99', name: "Import Export"}
]

const frequent = [
    {
        id : '1',
        name : 'Once'
    },
    {
        id : 'd',
        name : 'Daily'
    },
    {
        id : 'w',
        name : 'Weekly'
    },
    {
        id : 'bw',
        name : 'Bi-Weekly'
    },
    {
        id : 'm',
        name : 'Monthly'
    },
    {
        id : 'q',
        name : 'Quarterly'
    },
    {
        id : 'ba',
        name : 'Bi-Annually'
    },
    {
        id: 'a',
        name: 'Annually'
    },
    {
        id: 'o',
        name: 'Other'
    }
]

const editStyles = {
    root: { alignItems: 'flex-start'},

    inlineBlock: {
        display: 'inline-flex',
        marginRight: '8px',
    },
};

const SetTrainingEdit=({classes, ...props }) => (

    <Edit
        title='Edit Training Setup'
        {...props}

        actions={<TrainingActions />}
        >



       <TabbedForm  toolbar={<TrainingToolbar />}>
            <FormTab label="Training" >
                <TextInput source='training_name' label = 'Training Name' validate={required()}/>
                <TextInput source='code' label = 'Training Code'  />
                <SelectInput source="frequency" label='Traning Frequency' choices={frequent}  validate={required()}   formClassName={classes.inlineBlock}/>
                <BooleanInput source="isactive" label='Is an Active Training?' formClassName={classes.inlineBlock} />

                <TextInput source='description' label = 'Description'  rowsMax={2} multiline fullWidth  />
            </FormTab>
            <FormTab label="Exam">
            <ArrayInput source="question" label="Question(s)">
                <SimpleFormIterator>
                <RichTextInput
                    source='passage'
                    label="Passage"
                />
                <TextInput
                    source="quest"
                    label="Question"
                    formClassName={classes.inlineBlock}
                    fullWidth
                    validate={required()}
                />
                <ArrayInput source="Choices" label="Choice(s)">
                    <SimpleFormIterator>
                    <TextInput
                        source="answer"
                        label=""
                        fullWidth
                        formClassName={classes.inlineBlock}
                    />
                    <BooleanInput
                        source="isAnswere"
                        label="Is this an answer?"
                        formClassName={classes.inlineBlock}
                    />
                    </SimpleFormIterator>
                </ArrayInput>
                </SimpleFormIterator>
            </ArrayInput>

            <TextInput
                type="number"
                source="passing_percentage"
                label="Passing Percentage"
                validate={required()}
            />
            <TextInput source="comments" label="Comments" />

            </FormTab>
            <FormTab label="Roles" >
              <TitleCheckCom props={props}  source="roles" />
              <UserCheckCom  props={props}  source="users" />
            </FormTab>

        </TabbedForm>

    </Edit>
)

export default  withStyles(editStyles)(SetTrainingEdit)

